// Mock data for L&D Controls Ltd website (frontend-only teaser)

export const company = {
  name: "L&D Controls Ltd",
  shortName: "L&D Controls",
  tagline: "Window Controls  |  Automation  |  Electrical Solutions",
  companyNumber: "17409792",
  website: "www.ld-controls.com",
  email: "enquiries@ld-controls.com",
  logo: "/ld-logo.png",
  phonePrimary: "07786 733 989",
};

export const directors = [
  {
    name: "Dominic Jackson",
    role: "Director",
    phone: "07786 733 989",
    email: "dom@ld-controls.com",
    bio: "Dominic leads L&D Controls with a hands-on approach to every project. With extensive experience across manual and automated window control systems, he works directly with clients and site teams to deliver practical, reliable solutions — from a single remote window opener to large multi-storey installations.",
  },
  {
    name: "Leslie Millward",
    role: "Director",
    phone: "07533 841657",
    email: "les@ld-controls.com",
    bio: "Leslie brings deep technical knowledge of natural ventilation, actuators and electrical solutions. He oversees installations and quality on site, ensuring every system is specified correctly, installed to the highest standard and commissioned to perform for years to come.",
  },
];

export const services = [
  {
    id: "installation",
    icon: "Wrench",
    title: "Installation",
    short: "Full nationwide installation of manual and electric window control systems.",
    body: "Our experienced engineers provide a complete nationwide installation service for manual Teleflex winders, electric chain and rack actuators, and full natural ventilation systems. From survey and specification through to commissioning, we handle every project requirement — residential, commercial, healthcare and education.",
  },
  {
    id: "tender",
    icon: "FileText",
    title: "Tender Enquiries & Quotations",
    short: "Detailed, competitive quotations for projects of every size.",
    body: "We work with architects, main contractors and specifiers to provide accurate tender responses and quotations. With first-hand product knowledge we recommend the right products for the application, always working within budget without compromising on quality.",
  },
  {
    id: "direct-sales",
    icon: "ShoppingCart",
    title: "Direct Sales",
    short: "Supply of winders, actuators, controls and spare parts.",
    body: "Need the components only? We supply manual winders, electric actuators, control panels, switches and replacement parts directly, with expert guidance to make sure you order exactly what you need for your window and ventilation requirements.",
  },
  {
    id: "expert",
    icon: "Lightbulb",
    title: "Expert Advice",
    short: "Specialist guidance on natural ventilation and window controls.",
    body: "With decades of combined experience in window controls and natural ventilation, we offer genuine expert advice. Whether you are planning a new build, refurbishment or maintenance programme, we help you choose the most effective and reliable solution.",
  },
];

export const products = [
  {
    id: "teleflex-manual-winders",
    name: "Teleflex Manual Window Winders",
    category: "Manual Controls",
    image: "/projects/IMG_5496.jpg",
    summary: "Reliable manual winder gearboxes and spindles for opening high-level and out-of-reach windows.",
    features: [
      "Smooth, precise manual operation",
      "Ideal for high-level and restricted-access windows",
      "Wide range of spindle lengths and gearbox ratios",
      "Durable, low-maintenance mechanism",
    ],
  },
  {
    id: "electric-chain-actuators",
    name: "Electric Chain Actuators",
    category: "Electric Motors",
    image: "/projects/IMG_6519.jpg",
    summary: "Compact 24V electric chain motors for automatic opening of casement and top-hung windows.",
    features: [
      "Quiet, powerful 24V operation",
      "Adjustable stroke lengths",
      "Synchronised multi-window control",
      "Discreet, modern design",
    ],
  },
  {
    id: "natural-ventilation",
    name: "Natural Ventilation Systems",
    category: "Automation",
    image: "/projects/IMG_6515.jpg",
    summary: "Complete automatic natural ventilation solutions with sensors, controls and weather response.",
    features: [
      "Temperature, CO₂ and rain sensing",
      "Automatic & timed opening schedules",
      "BMS integration available",
      "Improved comfort and air quality",
    ],
  },
];

export const caseStudies = [
  {
    id: "riverside-newbuild",
    title: "Riverside New Build Homes",
    sector: "Residential",
    image: "/projects/IMG_5832.jpg",
    excerpt: "Electric chain actuators installed to high-level casement windows across a new residential development for easy, remote ventilation.",
  },
  {
    id: "ensuite-ventilation",
    title: "En-suite & Bathroom Ventilation",
    sector: "Residential",
    image: "/projects/IMG_6154.jpg",
    excerpt: "Discreet actuators and manual winders fitted to obscure-glazed bathroom windows for controlled, draught-free ventilation.",
  },
  {
    id: "city-apartments",
    title: "City Centre Apartments",
    sector: "Commercial",
    image: "/projects/IMG_5727.jpg",
    excerpt: "Automatic opening windows integrated into a high-rise apartment scheme, providing safe natural ventilation at height.",
  },
  {
    id: "heritage-bathroom",
    title: "Heritage Property Refurbishment",
    sector: "Residential",
    image: "/projects/IMG_5496.jpg",
    excerpt: "Manual Teleflex winder system retro-fitted to a traditional tiled bathroom, keeping controls neatly within reach.",
  },
  {
    id: "office-fitout",
    title: "Commercial Office Fit-Out",
    sector: "Commercial",
    image: "/projects/IMG_5497.jpg",
    excerpt: "Rack-arm actuators and manual winders combined to ventilate large curtain-wall glazing in a modern office refurbishment.",
  },
];

export const testimonials = [
  {
    quote: "L&D Controls delivered our window automation on time and on budget. The install team was tidy, professional and clearly knew the products inside out.",
    name: "Site Manager",
    role: "Residential Developer",
  },
  {
    quote: "Great technical advice from the very first enquiry. They specified exactly the right actuators for our high-level windows and the finish is excellent.",
    name: "Facilities Manager",
    role: "Commercial Client",
  },
  {
    quote: "We've used L&D for several projects now. Reliable products, fair pricing and a genuinely helpful, knowledgeable team.",
    name: "Project Architect",
    role: "Architecture Practice",
  },
];

export const stats = [
  { value: "25+", label: "Years combined experience" },
  { value: "1000+", label: "Windows automated" },
  { value: "UK", label: "Nationwide installation" },
  { value: "100%", label: "Dedicated to quality" },
];

export const sectors = [
  "Residential",
  "Commercial",
  "Education",
  "Healthcare",
  "Public Buildings",
  "New Build & Refurbishment",
];
